module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-592.db377ca5.jpg";